import { apiSlice } from './apiSlice';
import { TRANSFERS_URL } from '../constants';

export const transfersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new transfer
    createTransfer: builder.mutation({
      query: (transfer) => ({
        url: TRANSFERS_URL,
        method: 'POST',
        body: transfer,
      }),
    }),
    // Get transfer details by ID
    getTransferDetails: builder.query({
      query: (id) => ({
        url: `${TRANSFERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get logged-in user's transfers
    getMyTransfers: builder.query({
      query: () => ({
        url: `${TRANSFERS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get all transfers (Admin view)
    getTransfers: builder.query({
      query: () => ({
        url: TRANSFERS_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // Mark a transfer as delivered (Admin action)
    deliverTransfer: builder.mutation({
      query: (transferId) => ({
        url: `${TRANSFERS_URL}/${transferId}/deliver`,
        method: 'PUT',
      }),
    }),

    updateTransfer: builder.mutation({
              query: (data) => ({
                url: `${TRANSFERS_URL}/${data.transferId}`,
                method: 'PUT',
                body: data, // Make sure this contains `images` as an array
              }),
              invalidatesTags: ['Transfers'],
            }),
            uploadTransferImages: builder.mutation({ // Updated to handle multiple images
              query: (data) => ({
                url: `/api/upload`,
                method: 'POST',
                body: data, // Ensure this is a `FormData` object containing multiple images
              }),
            }),
        
    // Delete a transfer (Admin action)
    deleteTransfer: builder.mutation({
      query: (transferId) => ({
        url: `${TRANSFERS_URL}/${transferId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useCreateTransferMutation,
  useGetTransferDetailsQuery,
  useGetMyTransfersQuery,
  useGetTransfersQuery,
  useUpdateTransferMutation,
  useUploadTransferImagesMutation, // Updated for multiple images
  useDeliverTransferMutation,
  useDeleteTransferMutation,
} = transfersApiSlice;